import { all } from "redux-saga/effects";
import authSagas from "./Auth";
import NotificationSaga from "./Notification";

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    NotificationSaga(),
  ]);
}
